/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ReasonType } from "./reason-type";

/**
 *
 * @export
 * @interface ProtectReason
 */
export interface ProtectReason {
  /**
   *
   * @type {ReasonType}
   * @memberof ProtectReason
   */
  type: ReasonType;
  /**
   *
   * @type {number}
   * @memberof ProtectReason
   */
  count?: number | null;
  /**
   *
   * @type {string}
   * @memberof ProtectReason
   */
  value?: string | null;
}
